import Modal from "@via/components/modal.tsx";
import { ModalSize } from "@via/utils/constants.tsx";
import { type FC, useState } from "react";
import { RocketLaunchIcon } from "@heroicons/react/24/outline";
import UserUpgrade from "@via/pages/authentication/user-upgrade/user-upgrade.tsx";

interface UpgradeModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const UpgradeModal: FC<UpgradeModalProps> = ({ open, setOpen }) => {
  const [isUserConfirmed, setIsUserConfirmed] = useState(false);

  const handleUpgrade = async (): Promise<void> => {
    setIsUserConfirmed(true);
  };

  const handleClose = (): void => {
    setIsUserConfirmed(false);
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      onCancel={() => setIsUserConfirmed(false)}
      title="Upgrade Your Account"
      showButtons={false}
      size={ModalSize.Large}
      width={800}>
      {isUserConfirmed ? (
        <div>
          <UserUpgrade onClose={handleClose} />
        </div>
      ) : (
        <div>
          <p className="my-4 text-sm text-gray-600">
            You need to upgrade your account to access advanced features of
            Foundry. Unlock premium features and get the most out of your
            experience.
          </p>

          <div className="flex flex-shrink-0 justify-end gap-4 pt-4">
            <button
              id="app-create-cancel2"
              type="button"
              className="flex-1 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              onClick={() => setOpen(false)}>
              Maybe Later
            </button>
            <button
              id="app-create-save2"
              type="button"
              className="flex-1 inline-flex items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={() => handleUpgrade()}>
              <RocketLaunchIcon className="h-4 w-4 mr-2" /> Upgrade Now
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default UpgradeModal;
